import * as Yup from 'yup';

// Validation schema for the contact form
const ValidationSchema = Yup.object({
  user_name: Yup.string().required('Name is required'),
  user_email: Yup.string().email('Invalid email address').required('Email address is required'),
  subject: Yup.string().required('Subject is required'),
  message: Yup.string().max(500, 'Message cannot exceed 500 characters').required('Message is required'),
});

export default ValidationSchema;
